import axios from 'axios';
import APIConfig from './commerRealApiConfiguration.json';
// import axios from 'axios';

type SortDirections = 'ASC' | 'DESC';

export interface PositionSearchParameters {
	LanguageCode: string;
	SearchParameters: SearchParameters;
	SearchCriteria: SearchCriteria[];
}

interface SearchParameters {
	CountItem: string | number;
	FirstItem: string | number;
	MatchedObjectDescrptor: string[];
	Sort: Sort[];
}

interface Sort {
	Criterion: string;
	Direction: SortDirections;
}

interface SearchCriteria {
	CriterionName: string;
	CriterionValue: string;
}

export interface PositionList {
	LanguageCode: string;
	SearchResult: SearchResult;
}

interface SearchResult {
	UserArea?: any;
	SearchResultCount: number;
	SearchResultCountAll: number;
	SearchResultItems: SearchResultItem[];
}

export interface SearchResultItem {
	MatchedObjectId: string;
	RelevanceRank: number;
	RelevanceScore: number;
	MatchedObjectDescriptor: SearchResultData;
}
interface SearchResultData {
	ID: string;
	ApplyURI: string[];
	CareerLevel: Codes[];
	JobCategory: Codes[];
	LogoURI: string[];
	Organization: string;
	OrganizationName: string;
	PositionID: string;
	PositionIndustry?: Codes[];
	PositionLocation: Location[];
	PositionOfferingType?: Codes[];
	PositionTitle: string;
	PositionURI: string;
	PositionSchedule?: Codes[];
	PositionShortURI: string;
	PublicationChannel: Channel[];
	PublicationCode: string;
	PublicationEndDate: string;
	PublicationLanguage: Codes;
	PublicationStartDate: string;
	ParentOrganization: string;
	ParentOrganizationName: string;
	TargetGroup?: Codes[];
}

interface Codes {
	Code: string;
	Name: string;
}

export interface Option {
	id: string;
	label: string;
}

interface Channel {
	Id: number;
	StartDate: string;
	EndDate: string;
}

interface Location {
	Continent: string;
	ContinentName: string;
	Country: string;
	CountryName: string;
	CountryCode: string;
	CountrySubDivision: string;
	CountrySubDivisionName: string;
	City: string;
	CityName: string;
	PostalCode: string;
	StreetName: string;
	BuildingNumber: string;
	Longitude: number;
	Latitude: number;
}

export const getPositions = async (
	baseUrl: string,
	language: string,
	params?: PositionSearchParameters
): Promise<PositionList> => {
	const searchQuery = params ? params : APIConfig;

	if (language.toUpperCase() !== searchQuery?.LanguageCode) {
		searchQuery.LanguageCode = language.toUpperCase();
	}

	const searchURL = `${baseUrl}/?data=${encodeURI(JSON.stringify(searchQuery))}`;

	let returnValue;
	await axios.get(searchURL).then((result) => {
		returnValue = result.data;
	});
	return returnValue;
};
